import { render, staticRenderFns } from "./dynamic_tables_lista.vue?vue&type=template&id=f2195654&"
import script from "./dynamic_tables_lista.vue?vue&type=script&lang=ts&"
export * from "./dynamic_tables_lista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports